import { render, staticRenderFns } from "@/manager/convocation/views/convocationDetail/postponeList/postponeList.pug?vue&type=template&id=5b9d3aec&scoped=true&lang=pug&external"
import script from "./postponeList.view.vue?vue&type=script&lang=ts"
export * from "./postponeList.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/convocation/views/convocationDetail/postponeList/postponeList.scss?vue&type=style&index=0&id=5b9d3aec&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d3aec",
  null
  
)

export default component.exports